import {
  AppBar,
  Box,
  Button,
  Grid,
  Tab,
  Tabs,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SaveIcon from '@mui/icons-material/Save';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { SiteDTO } from '@beable/roster-backend-client-v1';
import Header from '../Header/Header';
import CustomerAndSiteSelector from '../Common/CustomerAndSiteSelector';
import BasePanel from '../Common/Layout/BasePanel';
import { BasePanelBox } from '../Common/Layout/BasePanelBox';
import BaseSheet from '../Common/Layout/BaseSheet';
import { StyledPanelHeader } from '../Common/Layout/PanelHeader';
import AssessmentDatesTab from './AssessmentDatesTab';
import SchoolHoursTab from './SchoolHoursTab';
import { getStyles } from './styles';

enum DatesAndHoursTabs {
  Dates = 'Dates',
  SchoolHours = 'School Hours',
}

export default function AssessmentDatesAndHours() {
  const theme = useTheme();
  const styles = getStyles(theme);
  const navigate = useNavigate();
  const [site, setSite] = useState<SiteDTO | undefined>(undefined);
  const [activeTab, setActiveTab] = useState<DatesAndHoursTabs>(DatesAndHoursTabs.Dates);

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: DatesAndHoursTabs
  ) => {
    setActiveTab(newValue);
  };

  const handleSiteChange = (selectedSite: SiteDTO | undefined) => {
    setSite(selectedSite);
    setActiveTab(DatesAndHoursTabs.Dates);
  };

  const handleExit = () => {
    navigate(-1);
  };

  const handleSave = () => {
    // Save handler will be implemented when tab forms are added
  };

  return (
    <>
      <Header />
      <Grid container>
        <BasePanel>
          <BasePanelBox>
            <StyledPanelHeader header="Assessment Dates & Hours" />
            <Grid container size={12}>
              <CustomerAndSiteSelector onSiteSelect={handleSiteChange} />
            </Grid>
          </BasePanelBox>
        </BasePanel>
        <BaseSheet widerPaper>
          {site?.id ? (
            <>
              <AppBar position="static">
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  textColor="inherit"
                  indicatorColor="secondary"
                >
                  <Tab
                    label="Assessment Dates"
                    value={DatesAndHoursTabs.Dates}
                  />
                  <Tab
                    label="School Hours"
                    value={DatesAndHoursTabs.SchoolHours}
                  />
                </Tabs>
              </AppBar>

              {activeTab === DatesAndHoursTabs.Dates && (
                <AssessmentDatesTab />
              )}

              {activeTab === DatesAndHoursTabs.SchoolHours && (
                <SchoolHoursTab />
              )}

              <Box sx={styles.actions}>
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={handleExit}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleSave}
                  startIcon={<SaveIcon />}
                >
                  Save
                </Button>
              </Box>
            </>
          ) : null}
        </BaseSheet>
      </Grid>
    </>
  );
}
